import React, {useEffect} from 'react';
import StatCard from './StatCard';
import { getDashboard } from '../../api';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Chip,
  Container,
} from '@mui/material';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import OnlineOffline from './OnlineOffline';
import SampleGridCharts from './SampleGridCharts';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);


const EnergyDashboard = () => {
  const consumptionData = {
    labels: ['2025-11-07', '2025-11-08', '2025-11-09', '2025-11-10', '2025-11-11', '2025-11-12'],
    datasets: [
      {
        label: 'Energy-KWH (EB)',
        data: [485, 490, 495, 465, 485, 280],
        borderColor: '#10b981',
        backgroundColor: 'rgba(16, 185, 129, 0.1)',
        borderWidth: 3,
        fill: true,
        tension: 0.4,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointBackgroundColor: '#10b981',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
      },
    ],
  };

  const generationData = {
    labels: ['2025-11-07', '2025-11-08', '2025-11-09', '2025-11-10', '2025-11-11'],
    datasets: [
      {
        label: 'Energy Generated (kWh)',
        data: [85, 335, 145, 225, 165],
        borderColor: '#8b5cf6',
        backgroundColor: 'rgba(139, 92, 246, 0.1)',
        borderWidth: 3,
        fill: true,
        tension: 0.4,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointBackgroundColor: '#8b5cf6',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          padding: 20,
          font: { size: 13, weight: '500' },
        },
      },
      tooltip: {
        backgroundColor: '#fff',
        titleColor: '#111827',
        bodyColor: '#6b7280',
        borderColor: '#e5e7eb',
        borderWidth: 1,
        padding: 12,
        boxPadding: 6,
        usePointStyle: true,
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.parsed.y} kWh`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: { color: '#f3f4f6', drawBorder: false },
        ticks: {
          color: '#6b7280',
          font: { size: 12 },
          callback: (value) => value + ' kWh',
        },
      },
      x: {
        grid: { display: false, drawBorder: false },
        ticks: {
          color: '#6b7280',
          font: { size: 12 },
          maxRotation: 45,
        },
      },
    },
  };

 
const fetchData = async () => {
    try {
      const response = await getDashboard();
      console.log("response");
      console.log(response);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  fetchData();



  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh', py: { xs: 3, md: 6 } }}>
      <Container maxWidth="xl">
       

        {/* 🟢 4-Section Row (includes online/offline) */}
        <Grid container spacing={3} sx={{ mb: 5 }}>

          {/* Online / Offline Status */}
          <Grid item xs={12} sm={6} md={3}>
             <OnlineOffline />
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
                title="-"
                value="-"
                icon='<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#744900ff"><path d="m456-200 174-340H510v-220L330-420h126v220Zm24 120q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>'
                color="#744900ff"
                bgGradient="linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)"
              />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
             <StatCard
                title="-"
                value="-"
                icon='<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#94004aff"><path d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z"/></svg>'
                color="#94004aff"
                bgGradient="linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%)"
              />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
             <StatCard
                title="-"
                value="-"
                icon='<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#9c0000ff"><path d="M400-440ZM120-80q-33 0-56.5-23.5T40-160v-560q0-33 23.5-56.5T120-800h320v80H120v560h560v-240h80v240q0 33-23.5 56.5T680-80H120Zm80-160h80v-280h-80v280Zm160 0h80v-400h-80v400Zm160 0h80v-160h-80v160Zm200-240q-30 0-59-9t-54-26l-15 14q-12 11-28.5 11T536-501q-11-11-11-28t11-28l16-16q-16-24-24-51t-8-56q0-83 58.5-141.5T720-880h200v200q0 83-58.5 141.5T720-480Zm0-80q50 0 85-35t35-85v-120H720q-50 0-85 35t-35 85q0 13 2.5 25t7.5 24l104-104q11-11 28-11t28 11q12 12 12 28.5T770-678L666-574q13 6 26.5 10t27.5 4Zm-6-119Z"/></svg>'
                color="#9c0000ff"
                bgGradient="linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)"
              />
          </Grid>

          
        </Grid>

        {/* Charts */}
        <Grid container spacing={3} sx={{ display: 'none' }}>
          <Grid item xs={12} lg={6}>
            <Card sx={{ boxShadow: 3, borderRadius: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 3, color: 'text.primary' }}>
                  Energy Consumption Trend (EB)
                </Typography>
                <Box sx={{ height: 320 }}>
                  <Line data={consumptionData} options={chartOptions} />
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} lg={6}>
            <Card sx={{ boxShadow: 3, borderRadius: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 3, color: 'text.primary' }}>
                  Energy Generated Trend
                </Typography>
                <Box sx={{ height: 320 }}>
                  <Line data={generationData} options={chartOptions} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <SampleGridCharts />
      </Container>
    </Box>
  );
};

export default EnergyDashboard;
